import { useState } from 'react'
import { CheckCircleIcon } from '@heroicons/react/24/solid'
import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown'
import '@leenguyen/react-flip-clock-countdown/dist/index.css'
import TicketForm from './TicketForm'
import ComingSoon from './ComingSoon'
import { isAdmin, isEnabled, isLocalHost, isStaging } from '../utils/common'

const COUNTDOWN_TARGET = new Date('2026-09-01T00:00:00+02:00')
const bypassCountdown = isAdmin || isLocalHost || isStaging
const showHeader = false // WordPress provides the page title

const TicketsCart = () => {
	const [countdownComplete, setCountdownComplete] = useState(new Date() >= COUNTDOWN_TARGET)

	const showForm = isEnabled && (bypassCountdown || countdownComplete)
	const showCountdown = isEnabled && !bypassCountdown && !countdownComplete
	const showComingSoon = !isEnabled

	return (
		<div className='max-w-4xl mx-auto px-4 py-8'>
			{/* Page Header - hidden when WordPress provides title */}
			{showHeader && (
				<header className='text-center mb-10'>
					<h1 className='font-display text-4xl md:text-5xl font-bold text-sage-800 mb-4'>
						Köp din biljett här
					</h1>
					<p className='text-sage-500 text-lg'>Jubileumsmässa 24–25 oktober 2026 · Solnahallen</p>
				</header>
			)}

			{/* Introduction text */}
			<div className='max-w-2xl mx-auto text-center mb-8'>
				<p className='text-sage-700 leading-relaxed'>
					Vill du vara säker på att komma in? Köp din biljett online i förväg! Det går att köpa
					biljett i entrén, men endast om vi inte nått maxkapacitet –{' '}
					<span className='font-medium text-sage-700'>förköpare har alltid förtur</span>. Mässan är
					öppen 10:00–18:00, men med förköp får du:
				</p>
			</div>

			{/* Benefits */}
			<div className='flex flex-wrap justify-center gap-6 mb-12'>
				{['Tidigare inträde (09.30)', 'Smidigare inpassering', 'SMS + email biljett'].map(
					(benefit, index) => (
						<div key={index} className='flex items-center gap-2'>
							<div className='flex-shrink-0 w-6 h-6 rounded-full bg-sage-100 flex items-center justify-center'>
								<CheckCircleIcon className='w-5 h-5 text-sage-500' />
							</div>
							<span className='text-sage-700 font-medium'>{benefit}</span>
						</div>
					),
				)}
			</div>

			{/* Conditional content: Form, Countdown, or ComingSoon */}
			{showForm && <TicketForm />}

			{showCountdown && (
				<div className='flex justify-center mb-12'>
					<FlipClockCountdown
						to={COUNTDOWN_TARGET}
						onComplete={() => setCountdownComplete(true)}
						showLabels={false}
						renderMap={[false, true, true, true]}
					/>
				</div>
			)}

			{showComingSoon && <ComingSoon />}

			{/* Footer Info */}
			<footer className='mt-12 pt-8 border-t border-sage-100'>
				<p className='text-center text-sage-500 text-base max-w-xl mx-auto'>
					Förköpsentrén öppnar kl 9.30, övriga kassor kl 10.00. Biljetten skickas till din
					e-postadress/SMS och du visar upp QR-koden i din telefon när du kommer till entrén. Barn
					under 12 år går in gratis i vuxens sällskap.
				</p>
				<p className='text-center mt-2 text-sage-500 text-base max-w-xl mx-auto'>
					﹡Obs! Bilden är en digital mockup och kan skilja sig något från den färdiga produkten.
				</p>
			</footer>
		</div>
	)
}

export default TicketsCart
